
import Components$002Emodule from "../../../src/StenaWeather.WeatherServiceUI.Client/Components/TimeZones/Components.module.css";
import { singleton, ofArray, map } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { concat, interpolate, join } from "../../fable_modules/fable-library-js.5.0.0/String.js";
import { toString } from "../../fable_modules/fable-library-js.5.0.0/Date.js";
import { utcNow, now, offset, toOffset } from "../../fable_modules/fable-library-js.5.0.0/DateOffset.js";
import { Fragment, useEffect, createElement, useState, useContext } from "react";
import React from "react";
import { DateTimeSettings, timeZoneContext } from "./Context.js";
import { fromMinutes, fromHours, minutes as minutes_2, totalHours } from "../../fable_modules/fable-library-js.5.0.0/TimeSpan.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { ofList } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { comparePrimitives, int32ToString } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0/Int32.js";
import { NumericTextInputModule_View } from "../StenaWebUI/Forms/NumericTextInput.js";
import { ButtonBase_ViewFlat, ButtonBase_ViewPrimary, ButtonBase_ViewSecondary } from "../StenaWebUI/Elements/Button.js";
import { SwitchModule_View } from "../StenaWebUI/Forms/Switch.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { ModalModule_view } from "../StenaWebUI/Modal/Modal.js";

export const cn = (() => {
    const styles = Components$002Emodule;
    const cnFn = (name) => (styles[name]);
    const cnFns = (names) => map((x) => (styles[x]), names);
    return {
        className: cnFn,
        classes: cnFns,
        prop: {
            className: (arg) => ["className", cnFn(arg)],
            classes: (arg_1) => ["className", join(" ", cnFns(arg_1))],
        },
    };
})();

export function DateTimeOffset_dateStr(d) {
    return toString(d, "yyyy-MM-dd");
}

export function DateTimeOffset_timeStr(d) {
    return toString(d, "HH:mm");
}

export function DateTimeOffset_dateTimeStr(d) {
    return (DateTimeOffset_dateStr(d) + " ") + DateTimeOffset_timeStr(d);
}

export function DateTimeOffset_adjustFromContext(ctx, dateTime) {
    if (ctx.Settings.UseLocalTime) {
        return toOffset(dateTime, ctx.Settings.TimeZoneOffset);
    }
    else {
        return toOffset(dateTime, 0);
    }
}

export function DateTimeOffset_dateTimeWithTimezone(d) {
    return DateTimeOffset_adjustFromContext(useContext(timeZoneContext), d);
}

export function DateTimeOffset_DateWithTimezone($props) {
    const dateTime = $props.dateTime;
    return DateTimeOffset_dateStr(DateTimeOffset_adjustFromContext(useContext(timeZoneContext), dateTime));
}

export function DateTimeOffset_TimeWithTimezone($props) {
    const dateTime = $props.dateTime;
    return DateTimeOffset_timeStr(DateTimeOffset_adjustFromContext(useContext(timeZoneContext), dateTime));
}

export function DateTimeOffset_DateTimeWithTimezone($props) {
    const dateTime = $props.dateTime;
    return DateTimeOffset_dateTimeStr(DateTimeOffset_adjustFromContext(useContext(timeZoneContext), dateTime));
}

export function TimezoneSettingsForm($props) {
    let p_1_1, p_1_2, p_1_4;
    const closeModal = $props.closeModal;
    const ctx = useContext(timeZoneContext);
    const patternInput = useState(~~totalHours(ctx.Settings.TimeZoneOffset));
    const setHoursState = patternInput[1];
    const hours = patternInput[0] | 0;
    const patternInput_1 = useState(minutes_2(ctx.Settings.TimeZoneOffset));
    const setMinutesState = patternInput_1[1];
    const minutes = patternInput_1[0] | 0;
    return HtmlHelper_createElement("div", ofArray([["className", cn.className("timezone-settings-form")], ["children", [HtmlHelper_createElement("div", ofArray([["className", cn.className("offset-settings")], ["children", [(p_1_1 = ofList(map((value_15) => value_15, ofArray([["value", int32ToString(hours)], ["max", 14], ["min", -14], ["onValueChange", (arg) => {
        const hours_1 = parse(arg, 511, false, 32) | 0;
        setHoursState(hours_1);
        if (Math.abs(hours_1) >= 14) {
            setMinutesState(0);
        }
        if ((hours_1 !== 0) && (minutes < 0)) {
            setMinutesState(Math.abs(minutes));
        }
    }]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), createElement(NumericTextInputModule_View, {
        p: p_1_1,
    })), ":", (p_1_2 = ofList(map((value_19) => value_19, ofArray([["value", int32ToString(minutes)], ["max", 59], ["min", (hours === 0) ? -59 : 0], ["onValueChange", (arg_1) => {
        const minutes_1 = parse(arg_1, 511, false, 32) | 0;
        if (Math.abs(hours) >= 14) {
            setMinutesState(0);
        }
        else {
            setMinutesState(minutes_1);
        }
    }]])), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), createElement(NumericTextInputModule_View, {
        p: p_1_2,
    }))]]])), ButtonBase_ViewSecondary(ofList(map((value_20) => value_20, ofArray([["onClick", () => {
        const nowOffset = offset(now());
        setHoursState(~~totalHours(nowOffset));
        setMinutesState(minutes_2(nowOffset));
    }], ["label", "Set local offset"]])), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    })), (p_1_4 = ofList(map((value_21) => value_21, ofArray([["label", "Save"], ["onClick", () => {
        ctx.SetSettings(new DateTimeSettings((hours < 0) ? (fromHours(hours) - fromMinutes(minutes)) : (fromHours(hours) + fromMinutes(minutes)), ctx.Settings.UseLocalTime));
        return closeModal();
    }]])), {
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    }), createElement(ButtonBase_ViewPrimary, {
        p: p_1_4,
    }))]]]));
}

export function CurrentSettingsDisplay() {
    let value, value_2, p_1_1;
    const ctx = useContext(timeZoneContext);
    const patternInput = useState(utcNow());
    const currentTime = patternInput[0];
    const patternInput_1 = useState(false);
    const setModalVisible = patternInput_1[1];
    const modalVisible = patternInput_1[0];
    useEffect(() => {
        const setup = (() => {
        const interval = window.setInterval(() => {
            patternInput[1](utcNow());
        }, 500);
        return () => {
            window.clearInterval(interval);
        };
    })();
        return setup;
        }, []);;
    const hoursOffset = `${interpolate("%02d%P()", [~~((value = totalHours(ctx.Settings.TimeZoneOffset), Math.abs(value)))])}`;
    const minutesOffset = `${interpolate("%02d%P()", [(value_2 = (minutes_2(ctx.Settings.TimeZoneOffset) | 0), Math.abs(value_2))])}`;
    const displayValue = (ctx.Settings.TimeZoneOffset >= 0) ? concat("UTC +", hoursOffset, ":", ...minutesOffset) : concat("UTC -", hoursOffset, ":", ...minutesOffset);
    let switch$;
    const xs_2 = [HtmlHelper_createElement("span", singleton(["children", singleton("UTC")])), (p_1_1 = ofList(map((value_6) => value_6, ofArray([["value", ctx.Settings.UseLocalTime], ["onValueChange", (_arg) => {
        ctx.SetSettings(new DateTimeSettings(ctx.Settings.TimeZoneOffset, !ctx.Settings.UseLocalTime));
    }]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), createElement(SwitchModule_View, {
        p: p_1_1,
    })), HtmlHelper_createElement("span", singleton(["children", singleton("Local")]))];
    switch$ = createElement(Fragment, defaultOf(), ...xs_2);
    const toggleModal = () => {
        setModalVisible(!modalVisible);
    };
    const settingsButton = ButtonBase_ViewFlat(ofList(map((value_10) => value_10, ofArray([["label", "Settings"], ["onClick", toggleModal], ["inverted", true]])), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }));
    const xs_10 = [HtmlHelper_createElement("div", ofArray([["className", cn.className("timezone-display")], ["children", [HtmlHelper_createElement("div", ofArray([["className", cn.className("time-display")], ["children", singleton(createElement(DateTimeOffset_TimeWithTimezone, {
        dateTime: currentTime,
    }))]])), HtmlHelper_createElement("div", ofArray([["className", cn.className("date-display")], ["children", singleton(createElement(DateTimeOffset_DateWithTimezone, {
        dateTime: currentTime,
    }))]])), HtmlHelper_createElement("div", ofArray([["className", cn.className("offset-display")], ["children", singleton(displayValue)]])), HtmlHelper_createElement("div", ofArray([["className", cn.className("offset-switch")], ["children", singleton(switch$)]])), HtmlHelper_createElement("div", ofArray([["className", cn.className("offset-setting-button")], ["children", singleton(settingsButton)]]))]]])), ModalModule_view(ofList(map((value_35) => value_35, ofArray([["isOpen", modalVisible], ["headerText", "Timezone Settings"], ["onRequestClose", toggleModal], ["width", "300px"], ["children", singleton(createElement(TimezoneSettingsForm, {
        closeModal: () => {
            setModalVisible(false);
        },
    }))]])), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }))];
    return createElement(Fragment, defaultOf(), ...xs_10);
}

